import breakfastHot from './images/breakfast/hot-breakfast.webp'
import breakfastCold from './images/breakfast/cold-breakfast.webp'
import breakfastBoth from './images/breakfast/both-breakfast.webp'
import afternoonTeaSweet from './images/afternoon-tea/sweet.webp'
import afternoonTeaSavoury from './images/afternoon-tea/savoury.webp'
import afternoonTeaBoth from './images/afternoon-tea/both.webp'
import lunchClassic from './images/lunch/classic.webp'
import lunchSpecialty from './images/lunch/specialty.webp'
import lunchBoth from './images/lunch/both.webp'
import sweetTreatsIceCream from './images/sweet-treats/ice-cream.webp'
import sweetTreatsPackagedSnacks from './images/sweet-treats/packaged-snacks.webp'
import sweetTreatsOther from './images/sweet-treats/other.webp'
import canapes from './images/canapes.jpg'
import fingerFoodSpecialty from './images/finger-food-specialty.jpeg'
import fingerFoodCanapes from './images/finger-food-canapes.jpg'
import americanCuisine from './images/specialty/americanCuisine.jpg'
import indianCuisine from './images/specialty/indianCuisine.png'
import italianCuisine from './images/specialty/italianCuisine.jpg'
import mexicanCuisine from './images/specialty/mexicanCuisine.jpg'
import middleEasternCuisine from './images/specialty/middleEasternCuisine.webp'
import thaiCuisine from './images/specialty/thaiCuisine.jpg'
import multipleCuisines from './images/specialty/multipleCuisines.png'
import { match } from 'ts-pattern'
import {
  eventDetailsServingType as commonEventDetailsServingType,
  occasionEventStyle,
  occasionFoodServiceTime,
  occasionOnsiteFacilities,
  occasionServiceStyle,
  occasionStaffServiceTime,
} from '../common'
import { DropdownType, EventDetailsType, OccasionFieldsAndEventDetails, TextType } from '../types'

const eventDetailsDrinks: EventDetailsType = {
  id: 'drinks',
  label: 'emma:eventDetails_drinksSubtitle', // "Would you like to add drinks?"
  type: 'radio',
  needs: [],
  prefill: false,
  options: [
    {
      label: 'common:yes',
      value: 'YES',
    },
    {
      label: 'common:no',
      value: 'NO',
    },
  ],
} as const

const eventDetailsDrinksType: EventDetailsType = {
  id: 'drinksRequirements',
  label: 'emma:eventDetails_drinksRequirementsSubtitle', // "What sort of drinks do you want?"
  type: 'checkbox',
  needs: [
    {
      id: 'drinks',
      value: 'YES',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Alcoholic',
      value: 'ALCOHOLIC_DRINKS',
    },
    {
      label: 'Non-Alcoholic',
      value: 'NON_ALCOHOLIC_DRINKS',
    },
    {
      label: 'Tea / Coffee',
      value: 'TEA_AND_COFFEE',
    },
    {
      label: 'Glass Hire',
      value: 'GLASS_HIRE',
    },
  ],
}

const eventDetailsServiceStyleAfternoonTea: EventDetailsType = {
  id: 'serviceStyle',
  label: 'What type of service style?',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Staffed',
      value: 'STAFFED',
    },
    {
      label: 'Delivered In',
      value: 'DELIVERED_IN',
    },
  ],
}

// Dropdown

const occasionEventType: DropdownType = {
  id: 'eventType',
  label: 'What type of event?',
  type: 'dropdown',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Corporate Function/Event',
      value: 'CORPORATE_FUNCTION_EVENT',
    },
    {
      label: 'Office Celebration',
      value: 'OFFICE_CELEBRATION',
    },
    {
      label: 'Cultural Event/Themed Day',
      value: 'CULTURAL_EVENT_THEMED_DAY',
    },
    {
      label: 'Team Lunch',
      value: 'TEAM_LUNCH',
    },
  ],
}

const occasionEventTypeOfficeCelebration: DropdownType = {
  id: 'eventTypeOfficeCelebration',
  label: undefined,
  type: 'dropdown',
  needs: [
    {
      id: 'eventType',
      value: 'OFFICE_CELEBRATION',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Birthday',
      value: 'BIRTHDAY',
    },
    {
      label: 'Retirement',
      value: 'RETIREMENT',
    },
    {
      label: 'Anniversary',
      value: 'ANNIVERSARY',
    },
    {
      label: 'Company milestone',
      value: 'COMPANY_MILESTONE',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ],
}

const occasionEventTypeCultural: DropdownType = {
  id: 'eventTypeCultural',
  label: undefined,
  type: 'dropdown',
  needs: [
    {
      id: 'eventType',
      value: 'CULTURAL_EVENT_THEMED_DAY',
    },
  ],
  prefill: false,
  options: [
    {
      label: 'Pancake Day',
      value: 'PANCAKE_DAY',
    },
    {
      label: "International Women's Day",
      value: 'INTERNATIONAL_WOMENS_DAY',
    },
    {
      label: 'Pride',
      value: 'PRIDE',
    },
    {
      label: 'Black History Month',
      value: 'BLACK_HISTORY_MONTH',
    },
    {
      label: 'Halloween',
      value: 'HALLOWEEN',
    },
    {
      label: 'Diwali',
      value: 'DIWALI',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ],
}

// Radio

const occasionEventOtherServiceStyle: EventDetailsType = {
  id: 'serviceStyle',
  label: 'What type of service style?',
  type: 'radio',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Cocktail Tray Service',
      value: 'COCKTAIL_TRAY_SERVICE',
    },
    {
      label: 'Buffet Staff Service',
      value: 'BUFFET_STAFF_SERVICE',
    },
    {
      label: 'Cook & Serve',
      value: 'COOK_AND_SERVE',
    },
  ],
}

// Image Cards

const occasionBreakfastType: EventDetailsType = {
  id: 'subtype',
  label: 'emma:breakfast_question',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'emma:breakfast_types_hot',
      label: undefined,
      value: 'HOT',
      image: breakfastHot,
    },
    {
      title: 'emma:breakfast_types_cold',
      label: undefined,
      value: 'COLD',
      image: breakfastCold,
    },
    {
      title: 'emma:breakfast_types_both',
      label: undefined,
      value: 'BOTH',
      image: breakfastBoth,
    },
  ],
}

const occasionAfternoonTeaType: EventDetailsType = {
  id: 'subtype',
  label: 'What ratio of sweet/savoury would you like?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'More sweet',
      label: undefined,
      value: 'SWEET',
      image: afternoonTeaSweet,
    },
    {
      title: 'More savoury',
      label: undefined,
      value: 'SAVOURY',
      image: afternoonTeaSavoury,
    },
    {
      title: 'Recommended - 50/50',
      label: undefined,
      value: 'BOTH',
      image: afternoonTeaBoth,
    },
  ],
}

const occasionLunchType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of lunch are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Classic Office Catering',
      label: 'salads, sandwiches, etc',
      value: 'CLASSIC',
      image: lunchClassic,
    },
    {
      title: 'Specialty Cuisine',
      label: 'unique cuisine options, e.g. Indian, Thai, Mexican',
      value: 'SPECIALTY',
      image: lunchSpecialty,
    },
    {
      title: 'Open to Both (Recommended)',
      label: "we'll provide a few classic & specialty options",
      value: 'BOTH',
      image: lunchBoth,
    },
  ],
}

const occasionDinnerType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of dinner are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Classic Office Catering',
      label: 'salads, sandwiches, etc',
      value: 'CLASSIC',
      image: lunchClassic,
    },
    {
      title: 'Specialty Cuisine',
      label: 'unique cuisine options, e.g. Indian, Thai, Mexican',
      value: 'SPECIALTY',
      image: lunchSpecialty,
    },
    {
      title: 'Open to Both (Recommended)',
      label: "we'll provide a few classic & specialty options",
      value: 'BOTH',
      image: lunchBoth,
    },
  ],
}

const occasionSpecialtyTypeOptions: EventDetailsType['options'] = [
  {
    title: 'European / Mediterranean',
    label: 'British, French, Italian, German, Austrian, Greek, Mediterranean',
    value: 'EUROPEAN_MEDITERRANEAN',
    image: italianCuisine,
  },
  {
    title: 'American',
    label: 'American, Hawaiian, Australian',
    value: 'AMERICAN',
    image: americanCuisine,
  },
  {
    title: 'Asian & Pacific',
    label:
      'Japanese, Thai, Korean, Vietnamese, Chinese, Malaysian, Indonesian, Sri Lankan, Taiwanese, Asian, Asian Fusion',
    value: 'ASIAN_PACIFIC',
    image: thaiCuisine,
  },
  {
    title: 'Indian',
    label: 'Indian, Sri Lankan',
    value: 'INDIAN',
    image: indianCuisine,
  },
  {
    title: 'Middle Eastern',
    label: 'Middle Eastern',
    value: 'MIDDLE_EASTERN',
    image: middleEasternCuisine,
  },
  {
    title: 'South/Latin American',
    label: 'Mexican, South American, Caribbean, Jamaican',
    value: 'SOUTH_AMERICAN',
    image: mexicanCuisine,
  },
  {
    title: 'Open to Any (Recommended)',
    label: '',
    value: 'ANY_CUISINE',
    image: multipleCuisines,
  },
]

const occasionSpecialtyLunchType: EventDetailsType = {
  id: 'specialtyType',
  label: 'Which specialty cuisine would you like?',
  type: 'image-cards',
  needs: [
    {
      id: 'subtype',
      value: 'SPECIALTY',
    },
  ],
  prefill: true,
  options: occasionSpecialtyTypeOptions,
}

const occasionSpecialtyDinnerType: EventDetailsType = {
  id: 'specialtyType',
  label: 'Which specialty cuisine would you like?',
  type: 'image-cards',
  needs: [
    {
      id: 'subtype',
      value: 'SPECIALTY',
    },
  ],
  prefill: true,
  options: occasionSpecialtyTypeOptions,
}

const occasionFingerFoodType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of finger food are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Canapés',
      label: undefined,
      value: 'CANAPES',
      image: canapes,
    },
    {
      title: 'Finger Food',
      label: undefined,
      value: 'FINGER_FOOD',
      image: fingerFoodSpecialty,
    },
    {
      title: 'Open to Both (Recommended)',
      label: undefined,
      value: 'BOTH',
      image: fingerFoodCanapes,
    },
  ],
}

const occasionSweetTreatsType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of sweet treats are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Ice cream',
      label: undefined,
      value: 'ICE_CREAM',
      image: sweetTreatsIceCream,
    },
    {
      title: 'Cakes, Cookies, Brownies, Macarons, Donuts',
      label: undefined,
      value: 'CAKES_COOKIES_BROWNIES_MACARONS_DONUTS',
      image: sweetTreatsOther,
    },
    {
      title: 'Branded Sweet Treats',
      label: undefined,
      value: 'BRANDED_SWEET_TREATS',
      image: sweetTreatsPackagedSnacks,
    },
  ],
}

// Checkboxes
export const occasionRequirements: EventDetailsType = {
  id: 'requirements',
  label: 'What is required?',
  type: 'checkbox',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Food',
      value: 'FOOD',
    },
    {
      label: 'Event Staffing',
      value: 'EVENT_STAFFING',
    },
    {
      label: 'Equipment Hire',
      value: 'EQUIPMENT_HIRE',
    },
    {
      label: 'Bartender / Mixologist',
      value: 'BARTENDER_MIXOLOGIST',
    },
  ],
}

const occasionRequirementsReduced: EventDetailsType = {
  id: 'requirements',
  label: 'What is required?',
  type: 'checkbox',
  needs: [],
  prefill: true,
  options: [
    {
      label: 'Food',
      value: 'FOOD',
    },
    {
      label: 'Equipment Hire',
      value: 'EQUIPMENT_HIRE',
    },
    {
      label: 'Bartender / Mixologist',
      value: 'BARTENDER_MIXOLOGIST',
    },
  ],
}

// Text Fields

const occasionEventTypeText: TextType = {
  id: 'eventType',
  placeholder: 'Example: Corporate Function / Event',
  label: undefined,
  inputLabel: 'What type of event?',
  type: 'text',
  needs: [],
  prefill: false,
}

const occasionEventTypeOther: TextType = {
  id: 'eventTypeOther',
  placeholder: 'Example: Corporate Function / Event',
  label: undefined,
  inputLabel: 'What is the occasion?',
  type: 'text',
  needs: [
    {
      id: 'eventTypeOfficeCelebration',
      value: 'OTHER',
    },
    {
      id: 'eventTypeCultural',
      value: 'OTHER',
    },
  ],
  prefill: false,
}

const occasionPancakeDayType = { ...occasionSweetTreatsType, id: 'pancakeDayType' }
const occasionInternationalWomensDayType = {
  ...occasionAfternoonTeaType,
  id: 'internationalWomensDayType',
}
const occasionEasterType = { ...occasionAfternoonTeaType, id: 'easterType' }
const occasionPrideType = { ...occasionAfternoonTeaType, id: 'prideType' }
const occasionHalloweenType = { ...occasionAfternoonTeaType, id: 'halloweenType' }

export const occasions = (code: string): OccasionFieldsAndEventDetails => {
  const result: OccasionFieldsAndEventDetails = {
    skip: false,
    fields: [],
    eventDetails: [],
  }
  match(code)
    .with('BREAKFAST', () => {
      result.fields.push(occasionBreakfastType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('LUNCH', () => {
      result.fields.push(occasionLunchType, occasionSpecialtyLunchType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('DINNER', () => {
      result.fields.push(occasionDinnerType, occasionSpecialtyDinnerType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('AFTERNOON_TEA', () => {
      result.eventDetails.push(
        eventDetailsServiceStyleAfternoonTea,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('SWEET_TREATS', () => {
      result.eventDetails.push(eventDetailsDrinks, eventDetailsDrinksType)
    })
    .with('FINGER_FOOD', () => {
      result.fields.push(occasionFingerFoodType)
      result.eventDetails.push(
        eventDetailsServiceStyleAfternoonTea,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('POP_UPS', () => {
      result.fields.push(
        occasionEventType,
        occasionEventTypeOfficeCelebration,
        occasionEventTypeCultural,
        occasionEventTypeOther,
        occasionRequirementsReduced,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventOtherServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(eventDetailsDrinks, eventDetailsDrinksType)
    })
    .with('LUNAR_NEW_YEAR', () => {
      result.skip = true
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('VALENTINES_DAY', () => {
      result.skip = true
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('PANCAKE_DAY', () => {
      result.fields.push(occasionPancakeDayType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('INTERNATIONAL_WOMENS_DAY', () => {
      result.fields.push(occasionInternationalWomensDayType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('EASTER', () => {
      result.skip = true
      result.fields.push(occasionEasterType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('CINCO_DE_MAYO', () => {
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('PRIDE', () => {
      result.fields.push(occasionPrideType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('SUMMER_PARTIES', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('PICNIC_PARTIES', () => {
      result.skip = true
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('BLACK_HISTORY_MONTH', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('DIWALI', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('HALLOWEEN', () => {
      result.fields.push(occasionHalloweenType)
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('THANKSGIVING', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('CHRISTMAS_PARTY', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(
        commonEventDetailsServingType,
        eventDetailsDrinks,
        eventDetailsDrinksType,
      )
    })
    .with('EVENT_OTHER', () => {
      result.fields.push(
        occasionEventTypeText,
        occasionRequirementsReduced,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionEventOtherServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(eventDetailsDrinks, eventDetailsDrinksType)
    })
  return result
}
